import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Tooltip } from '@mui/material';
import { Location } from '../../api/types';
import Card from '../../components/Card';
import CheckCircleIcon from '../../components/icons/CheckCircleIcon';
import CrossCircleIcon from '../../components/icons/CrossCircleIcon';
import TicketIcon from '../../components/icons/TicketIcon';

interface LocationCardProps {
    location: Location;
    onPress: () => void;
}

const LocationCard = (props: LocationCardProps) => {
    return (
        <Card onClick={props.onPress}>
            <h2
                className={
                    'flex grow truncate text-2xl font-semibold -tracking-[0.0225rem] ' +
                    'text-foreground text-wrap text-left'
                }
            >
                {props.location.name}
            </h2>
            <div className={'flex flex-row gap-1'}>
                {props.location.enabled ? (
                    <CheckCircleIcon />
                ) : (
                    <CrossCircleIcon />
                )}
                {props.location.status.bookable ? (
                    <TicketIcon className={'text-[#27AE60]'} />
                ) : (
                    <TicketIcon className={'text-[#E72525]'} />
                )}
                {props.location.status.notification && (
                    <Tooltip title={props.location.status.notification.text}>
                        <ErrorOutlineIcon
                            className={
                                {
                                    info: 'text-blue-500',
                                    warning: 'text-yellow-500',
                                    error: 'text-[#E72525]',
                                    success: 'text-[#27AE60]',
                                }[props.location.status.notification.type]
                            }
                        />
                    </Tooltip>
                )}
            </div>
        </Card>
    );
};

export default LocationCard;
